//=========================== Admin Simple Post=============================
import CreatePost from "../../Screen/Admin/Post/CreatePost";
import PendingPost from "../../Screen/Admin/Post/PendingPost";
import PostDetails from "../../Screen/Admin/Post/PostDetails";
import ApprovedPost from "../../Screen/Admin/Post/ApprovedPost";
import RejectPost from "../../Screen/Admin/Post/RejectPost";
import AllPost from "../../Screen/Admin/Post/AllPost";

//=========================== Admin Live Chat=============================
import LiveChatCreate from "../../Screen/Admin/LiveChat/LiveChatCreate";
import LiveChatEdit from "../../Screen/Admin/LiveChat/LiveChatEdit";
import LiveChatPending from "../../Screen/Admin/LiveChat/LiveChatPending";
import LiveChatApproved from "../../Screen/Admin/LiveChat/LiveChatApproved";
import LiveChatComplete from "../../Screen/Admin/LiveChat/LiveChatComplete";
import LiveChatDetails from "../../Screen/Admin/LiveChat/LiveChatDetails";

//=========================== Admin QnA=============================
import QnaDashboard from "../../Screen/Admin/QnA/QnaDashboard";
import CreateQnA from "../../Screen/Admin/QnA/CreateQnA";
import QnaPending from "../../Screen/Admin/QnA/QnaPending";
import QnAEdit from "../../Screen/Admin/QnA/QnAEdit";
import QnADetails from "../../Screen/Admin/QnA/QnADetails";
import QnaLive from "../../Screen/Admin/QnA/QnaLive";
import QnaCompleted from "../../Screen/Admin/QnA/QnaCompleted";
import QnaRejected from "../../Screen/Admin/QnA/QnaRejected";

//=========================== Admin Promo Video=============================
import AllPromoVideos from "../../Screen/Admin/PromoVideo/AllPromoVideos";
import LivePromoVideo from "../../Screen/Admin/PromoVideo/LivePromoVideo";
import UploadPromoVideo from "./Home/Pages/PromoVideos/Content/AddSession";
import PendingPromoVideo from "../../Screen/Admin/PromoVideo/PendingPromoVideo";
import EditPromoVideo from "./Home/Pages/PromoVideos/EditPromoVideo";
import ApprovedPromoVideo from "../../Screen/Admin/PromoVideo/ApprovedPromoVideo";
import RejectedPromoVideo from "../../Screen/Admin/PromoVideo/RejectedPromoVideo";

//=========================== Admin Fan Group =============================
import AdminApprovedFanGroup from "../../Screen/Admin/FanGroup/AdminApprovedFanGroup";
import AdminFanGroup from "../../Screen/Admin/FanGroup/AdminFanGroup";
import AdminPendingFanGroup from "../../Screen/Admin/FanGroup/AdminPendingFanGroup";
import ApprovedFanGroup from "./Home/Pages/AdminFanGroup/ApprovedFanGroup/ApprovedFanGroup";
import CompletionBetweenStars from "./Home/Pages/AdminFanGroup/CompletionBetweenStars/CompletionBetweenStars";
import AdminFanGroupLive from "../../Screen/Admin/FanGroup/AdminFanGroupLive";
import CreateFanGroup from "./Home/Pages/AdminFanGroup/CreateFanGroup/CreateFanGroup";
import EditPendingFanGroup from "./Home/Pages/AdminFanGroup/EditPendingFanGroup/EditPendingFanGroup";
import FanGroupInvitation from "./Home/Pages/AdminFanGroup/FanGroupInvitation/FanGroupInvitation";
import PendingFanGroup from "./Home/Pages/AdminFanGroup/PendingFanGroup/PendingFanGroup";

import LearningSessionLiveStream from "../../VideoCall";
import CreateLearningSession from "../Admin/Home/Pages/AdminLearningSession/Content/AddSessionForm";
import PendingLearningSessionDetails from "../Admin/Home/Pages/AdminLearningSession/PendingPostDetails";

import LearningSession from "../Admin/Home/Pages/AdminLearningSession/AllPost";
import LearningSessionLive from "../Admin/Home/Pages/AdminLearningSession/LearningSessionLive";
import LearningSessionDetails from "../Admin/Home/Pages/AdminLearningSession/LearningSessionDetails";
import LearningSessionEvaluation from "../Admin/Home/Pages/AdminLearningSession/LearningSessionEvaluation";
import LearningSessionEvaluationDetails from "../Admin/Home/Pages/AdminLearningSession/LearningSessionEvaluationDetails";
import LearningSessionEvaluationMarkSheet from "../Admin/Home/Pages/AdminLearningSession/LearningSessionEvaluationMarkSheet";
import LearningLiveSession from "./Home/Pages/AdminLearningSession/LearningLiveSession";
import LearningSessionPending from "../Admin/Home/Pages/AdminLearningSession/LearningSessionPending";
import LearningSessionCompleted from "../Admin/Home/Pages/AdminLearningSession/LearningSessionCompleted";

import LiveChatLive from "./Home/Pages/LiveChatSpStar/LiveChatContent1";
import LiveChatDetails1 from "./Home/Pages/LiveChatSpStar/LiveChatContentDetails";

import LiveChatDashboard from "../Admin/Home/Pages/LiveChatSpStar/LiveChatDashboard";

import LiveChatProfileCreate from "../Admin/Home/Pages/LiveChatSpStar/LiveChatProfileCreate";
import EventScheduleDatePick from "../Admin/Home/Pages/ScheduleCreate/EventScheduleDatePick/EventScheduleDatePick";
import AuditionRounds from "../AuditionAdmin/AuditonRounds/AuditionRoundsOld";
import NotFound from "../Pages/Errors/Error";
import AdminDashEvent from "./Dashboard/AdminDashEvent";
import AdminEventCategory from "./Dashboard/AdminEventCategory";
import AdminEventRequest from "./Dashboard/AdminEventRequest";
import AdminMainDashboard from "./Dashboard/AdminMainDashboard";
import AdminVideoJoin from "./Dashboard/Content/AdminVideoJoin";
import FanbaseAdmin1 from "./FanbaseGroup/FanbaseAdmin1";
import AddSuperStar from "./Home/Pages/AddSuperStar/AddSuperStar";
import AdminAudition2 from "./Home/Pages/AdminAudition/AdminAudition2";
import AdminAuditionCreateEvent from "./Home/Pages/AdminAudition/AdminAuditionCreateEvent/AdminAuditionCreateEvent";
import AdminAuditionLive from "./Home/Pages/AdminAudition/AdminAuditionLive/AdminAuditionLive";
import AdminAuditionLiveVideoFilter from "./Home/Pages/AdminAudition/AdminAuditionLiveVideoFilter/AdminAuditionLiveVideoFilter";
import AdminAuditionVideo from "./Home/Pages/AdminAudition/AdminAuditionVideo/AdminAuditionVideo";
import AdminAuditionVideoShow from "./Home/Pages/AdminAudition/AdminAuditionVideoShow/AdminAuditionVideoShow";
import AdminAuditionVideoShow2 from "./Home/Pages/AdminAudition/AdminAuditionVideoShow/AdminAuditionVideoShow2";
import AdminPendingAudition from "./Home/Pages/AdminAudition/AdminPendingAudition/AdminPendingAudition";
import AdminRequestForApproval from "./Home/Pages/AdminAudition/AdminRequestForApproval/AdminRequestForApproval";
import AdminRoundOneAppeal from "./Home/Pages/AdminAudition/AdminRoundOneAppeal/AdminRoundOneAppeal";
import AdminRoundTwoAppeal from "./Home/Pages/AdminAudition/AdminRoundTwoAppeal/AdminRoundTwoAppeal";
import CreateCertificate from "./Home/Pages/AdminAudition/AuditionDasboard/Content/Certificate/CreateCertificate";
import RequestCertificate from "./Home/Pages/AdminAudition/AuditionDasboard/Content/Certificate/RequestCertificate";
import EventRequestApproval from "./Home/Pages/AdminAudition/AuditionDasboard/Content/Event/EventRequestApproval";
import EventsLive from "./Home/Pages/AdminAudition/AuditionDasboard/Content/Event/EventsLive";
import PendingEventAudition from "./Home/Pages/AdminAudition/AuditionDasboard/Content/Event/PendingEventAudition";
import DashboardAudition from "./Home/Pages/AdminAudition/AuditionDasboard/DashboardAudition";
import PendingAudition from "./Home/Pages/AdminAudition/PendingAudition/PendingAudition";

// Marketplace related route

import SouvenirMain from "./Home/Pages/StarShowcase/Souvenir/SouvenirMain";
import CreateEditSouvenir from "./Home/Pages/StarShowcase/Souvenir/CreateEditSouvenir";
import DetailsSouvenir from "./Home/Pages/StarShowcase/Souvenir/DetailsSouvenir";
import SouvenirRegisteredList from "./Home/Pages/StarShowcase/Souvenir/SouvenirRegisteredList";
import SouvenirPaymentDueList from "./Home/Pages/StarShowcase/Souvenir/SouvenirPaymentDueList";
import SouvenirPaymentList from "./Home/Pages/StarShowcase/Souvenir/SouvenirPaymentList";
import SouvenirOrderInvoice from "./Home/Pages/StarShowcase/Souvenir/Invoice/SouvenirOrderInvoice";

// Marketplace related route
import Marketplace from "./Home/Pages/StarShowcase/Marketplace/MarketPlace/MarketPlace";
import AddProductFromMarketPlace from "./Home/Pages/StarShowcase/Marketplace/AddProductFromMarketPlace/AddProductFromMarketPlace";
import ConfirmEditMarketplace from "./Home/Pages/StarShowcase/Marketplace/ConfirmEditMarketplace/ConfirmEditMarketplace";
import EditProductMarketPlace from "./Home/Pages/StarShowcase/Marketplace/EditProductMarketPlace/EditProductMarketPlace";
import MarketPlaceOrderlist from "./Home/Pages/StarShowcase/Marketplace/MarketPlaceOrderlist/MarketPlaceOrderlist";
import MarketplaceOrderInvoice from "./Home/Pages/StarShowcase/Marketplace/MarketPlaceOrderlist/MarketplaceOrderInvoice";
import MarketplaceOrderView from "./Home/Pages/StarShowcase/Marketplace/MarketPlaceOrderlist/MarketplaceOrderView";
import OrderListMarketPlaceShow from "./Home/Pages/StarShowcase/Marketplace/OrderListMarketPlaceShow/OrderListMarketPlaceShow";
import ProductList from "./Home/Pages/StarShowcase/Marketplace/ProductList/ProductList";

// greeting related route
import AdminGreetings from "./Home/Pages/AdminGreetings/AdminGreetings";
import AdminGreetingsAllRequest from "./Home/Pages/AdminGreetingsAllRequest/NotifyGreetings/NotifyGreetingsContent";
import AdminGreetingsCompletedList from "./Home/Pages/AdminGreetingsCompletedList/AdminGreetingsCompletedList";
import AdminGreetingsRegisteredList from "./Home/Pages/AdminGreetingsRegisteredList/AdminGreetingsRegisteredList";
import AdminGreetingsForwarderdedToUserList from "./Home/Pages/AdminGreetingsForwarderdedToUserList/AdminGreetingsForwarderdedToUserList";
import AdminGreetingsForm from "./Home/Pages/AdminGreetings/AdminGreetingsForm/AdminGreetingsForm";
// import GreetingsDetails from "./Home/Pages/AdminGreetings/GreetingsReadyPage/GreetingsReadyPage";
import NotifySchedule from "./Home/Pages/AdminGreetings/NotifyGreetings/Content/NotifySchedule";
import NotifyScheduleView from "./Home/Pages/AdminGreetings/NotifyGreetings/Content/NotifyScheduleView";
import Notify from "./Home/Pages/AdminGreetings/NotifyGreetings/NotifyGreetingsContent";
import AdminLearningMain from "./Home/Pages/AdminLearningSession/AdminLearningMain/AdminLearningMain";
import LearningSessionResult from "./Home/Pages/AdminLearningSession/LearningSessionResult/LearningSessionResult";
import AddMeetUp from "./Home/Pages/AdminMeeupEvents/AddMeetup/AddMeetUp";
import AdminVideoChat from "./Home/Pages/AdminMeeupEvents/AdminVideoChat/AdminVideoChat";
import AdminVideoChatIcon from "./Home/Pages/AdminMeeupEvents/AdminVideoChat/AdminVideoChatIcon";
import EventDetails from "./Home/Pages/AdminMeeupEvents/EventDetails/EventDetails";
import EventSlot from "./Home/Pages/AdminMeeupEvents/EventSlot/EventSlot";
import EventSuccess from "./Home/Pages/AdminMeeupEvents/EventSlotSuccess/EventSuccess";

import AdminMeetupDashboard from "./Home/Pages/AdminMeeupEvents/AdminMeetupDashboard";
import LiveMeetUp from "./Home/Pages/AdminMeeupEvents/LiveMeetUp/LiveMeetUp";
import PendingMeetUpList from "./Home/Pages/AdminMeeupEvents/LiveMeetUp/PendingMeetupList";
import PendingMeetUp from "./Home/Pages/AdminMeeupEvents/PendingMeetUp/PendingMeetUp";
import CompletedMeetup from "./Home/Pages/AdminMeeupEvents/CompletedMeetup/CompletedMeetupList";

import AdminRegistration from "./Home/Pages/AdminRegistration/AdminRegistration";
import ApprovedOrDecline from "./Home/Pages/StarShowcase/Auction/ApprovedOrDecline";
import PendingProductDetails from "./Home/Pages/StarShowcase/Auction/PendingProductDetails";
import PendingProductList from "./Home/Pages/StarShowcase/Auction/PendingProductList";
import SoldProductList from "./Home/Pages/StarShowcase/Auction/SoldProductList";
import UnsoldProductList from "./Home/Pages/StarShowcase/Auction/UnsoldProductList";
import ConfirmOrEditAuction from "./Home/Pages/AdminSouvenir/ConfirmOrEditAuction/ConfirmOrEditAuction";
import AddProductSouvenir from "./Home/Pages/AdminSouvenir/Content/AddProduct/AddProductSouvenir";
import EditProductSouvenir from "./Home/Pages/AdminSouvenir/Content/AddProduct/EditProductSouvenir";
import LiveBiddingsCheckout from "./Home/Pages/StarShowcase/Auction/LiveBiddingsCheckout/LiveBiddingsCheckout";

import GrandFinish from "./Home/Pages/Auditions/Content/Finish/GrandFinish";
import AddSessionContent from "./Home/Pages/LiveChatSpStar/AddSessionContent";
import SCheduleViewAdmin from "./Home/Pages/LiveChatSpStar/Content/SCheduleViewAdmin";

import LiveChatProfile from "./Home/Pages/LiveChatSpStar/LiveChatProfile";
import LiveChatSchedule from "./Home/Pages/LiveChatSpStar/LiveChatSchedule";
import LiveChatSchedule2 from "./Home/Pages/LiveChatSpStar/LiveChatSchedule2";
import RegistertUser from "./Home/Pages/LiveChatSpStar/RegisterUser/RegistertUser";
import ScheduleCreate from "./Home/Pages/ScheduleCreate/ScheduleCreate";
import AdminBidding from "./Home/Pages/StarShowcase/Auction/AdminBidding/AdminBidding";
// import CricketJerserAdmin2 from "./Home/Pages/Souviner-admin/AdminBidding/CricketJerserAdmin2";
import UpcomingEvent from "./Home/Pages/UpcomingEvent/UpcomingEvent";
import WelcomeSuperStarPrint from "./Home/Pages/WelcomSuperStarPrint/WelcomeSuperStarPrint";
import ScheduleList from "./Home/Pages/ScheduleCreate/ScheduleList";

import LiveNowSouvenir from "./Home/Pages/AdminSouvenir/Content/LiveNowSouvenir";

import AddProductAuction from "./Home/Pages/StarShowcase/Auction/Content/AddProduct/AddProductAuction";
import EditProductAuction from "./Home/Pages/StarShowcase/Auction/Content/AddProduct/EditProductAuction";
import LiveNowAuction from "./Home/Pages/StarShowcase/Auction/Content/LiveNowAuction";

import LearningSessionEdit from "./Home/Pages/AdminLearningSession/LearningSessionEdit";
import EditMeetUp from "./Home/Pages/AdminMeeupEvents/AddMeetup/EditMeetup";
import RejectedLearningSession from "./Home/Pages/AdminLearningSession/RejectedLearningSession";

import EditSimplePost from "./Home/Pages/AdminPost/Content/EditSimplePost";
import PendingDetailsPromoVideo from "../../Screen/Admin/PromoVideo/DetailsPromoVideo";
import LiveVideoChat from "../../LiveVideoChat";
import RejectedProductList from "./Home/Pages/StarShowcase/Auction/RejectedProductList";
import EditSuperStar from "./Home/Pages/AddSuperStar/EditSuperStar";
import ScheduleListMonth from "./Home/Pages/ScheduleCreate/ScheduleListMonth";
import EventRequirement from "../Audition_static/Audition_admin/EventRequirement";
import SingleSchedule from "./MainDashboard/Screen/SingleSchedule";
import ScheduleTable from "./MainDashboard/Screen/ScheduleTable";
import AdminProfile from "./settings/AdminProfile";
import StarShowcase from "./MainDashboard/Screen/StarShowcase";
import Settings from "./MainDashboard/Reuse/Settings";

import QnaMsgBox from "../../Screen/SuperStar/FanGroup/Content/QnaMsgBox";
import CallDetails from "../SuperStar/Pages/StarLiveChat/CallDetails";

import E_Wallet from "../../Screen/E_Wallet";
import LearningUserList from "./Home/Pages/AdminLearningSession/LearningUserList";
import MarketplaceOrderInvoiceBng
  from "./Home/Pages/StarShowcase/Marketplace/MarketPlaceOrderlist/MarketplaceOrderInvoiceBng";
import AdminGreetingsView from "./Home/Pages/AdminGreetingsView/AdminGreetingsView";
import AuctionOrderView from "./Home/Pages/StarShowcase/Auction/AuctionOrderView";

const AdminRoute = [
  {
    path: "/superstar-admin/superstar-registration",
    exact: true,
    name: "Registration",
    component: AdminRegistration,
  },
  {
    path: "/superstar-admin/dashboard",
    exact: true,
    name: "Dashboard",
    component: AdminMainDashboard,
  },
  {
    path: "/jury-board-admin/dashboard",
    exact: true,
    name: "Dashboard",
    component: AdminMainDashboard,
  },
  {
    path: "/superstar-admin/e-wallet",
    exact: true,
    name: "e-wallet",
    component: E_Wallet,
  },

  {
    path: "/superstar-admin/event-date",
    exact: true,
    name: "Dashboard",
    component: AdminDashEvent,
  },
  {
    path: "/superstar-admin/event-category",
    exact: true,
    name: "Dashboard",
    component: AdminEventCategory,
  },
  {
    path: "/superstar-admin/event-pending",
    exact: true,
    name: "Dashboard",
    component: AdminEventRequest,
  },
  {
    path: "/superstar-admin/event-category/join",
    exact: true,
    name: "Dashboard",
    component: AdminVideoJoin,
  },

  // Profile
  {
    path: "/superstar-admin/profile",
    exact: true,
    name: "profile",
    component: AdminProfile,
  },

  {
    path: "/superstar-admin/profile-settings",
    exact: true,
    name: "profile",
    component: Settings,
  },

  // Schedule
  {
    path: "/superstar-admin/schedule/single",
    exact: true,
    name: "schedule",
    component: SingleSchedule,
  },
  {
    path: "/superstar-admin/star-showcase",
    exact: true,
    name: "star-showcase",
    component: StarShowcase,
  },
  {
    path: "/superstar-admin/schedule/date/:id/:type",
    exact: true,
    name: "schedule",
    component: ScheduleTable,
  },

  // Schedule Create Route
  {
    path: "/superstar-admin/schedule-create",
    exact: true,
    name: "schedule-create",
    component: ScheduleCreate,
  },
  // { path: "/superstar-admin/schedule-list", exact: true, name: "schedule-list", component: ScheduleList },
  {
    path: "/superstar-admin/schedule-list",
    exact: true,
    name: "schedule-list",
    component: ScheduleListMonth,
  },

  // Post Route
  {
    path: "/superstar-admin/post",
    exact: true,
    name: "PendingPost",
    component: AllPost,
  },
  {
    path: "/superstar-admin/post/create",
    exact: true,
    name: "CreatePost",
    component: CreatePost,
  },
  {
    path: "/superstar-admin/post/edit/:id",
    exact: true,
    name: "edit-Post",
    component: EditSimplePost,
  },
  {
    path: "/superstar-admin/post/pending",
    exact: true,
    name: "PendingPost",
    component: PendingPost,
  },
  {
    path: "/superstar-admin/post/details/:id",
    exact: true,
    name: "PendingPost",
    component: PostDetails,
  },
  {
    path: "/superstar-admin/post/approved",
    exact: true,
    name: "ApprovedPost",
    component: ApprovedPost,
  },
  {
    path: "/superstar-admin/post/reject",
    exact: true,
    name: "rejected",
    component: RejectPost,
  },

  // Learning Session Route
  {
    path: "/superstar-admin/learning-session",
    exact: true,
    name: "learning-session",
    component: LearningSession,
  },
  {
    path: "/superstar-admin/learning-session/pending",
    exact: true,
    name: "learning-session",
    component: LearningSessionPending,
  },
  {
    path: "/superstar-admin/learning-session/edit/:id",
    exact: true,
    name: "learning-session",
    component: LearningSessionEdit,
  },

  {
    path: "/superstar-admin/learning-session/live",
    exact: true,
    name: "learning-session",
    component: LearningSessionLive,
  },
  {
    path: "/superstar-admin/learning-session/completed",
    exact: true,
    name: "learning-session",
    component: LearningSessionCompleted,
  },
  {
    path: "/superstar-admin/learning-session/evaluation",
    exact: true,
    name: "learning-session",
    component: LearningSessionEvaluation,
  },
  {
    path: "/superstar-admin/learning-session/user-list",
    exact: true,
    name: "learning-session",
    component: LearningUserList,
  },
  {
    path: "/superstar-admin/learning-session/evaluation/:slug",
    exact: true,
    name: "learning-session",
    component: LearningSessionEvaluationDetails,
  },
  {
    path: "/superstar-admin/learning-session/evaluation/markSheet/:slug",
    exact: true,
    name: "learning-session",
    component: LearningSessionEvaluationMarkSheet,
  },
  {
    path: "/superstar-admin/learning-session/live-session",
    exact: true,
    name: "learning-session",
    component: LearningLiveSession,
  },
  {
    path: "/superstar-admin/learning-session/details/:id",
    exact: true,
    name: "learning-session",
    component: LearningSessionDetails,
  },
  {
    path: "/superstar-admin/learning-session/result",
    exact: true,
    name: "learning-session",
    component: LearningSessionResult,
  },
  {
    path: "/superstar-admin/learning-session/result-main",
    exact: true,
    name: "learning-session",
    component: AdminLearningMain,
  },
  {
    path: "/superstar-admin/learning-session/create",
    exact: true,
    name: "CreatePost",
    component: CreateLearningSession,
  },
  {
    path: "/superstar-admin/learning-session/rejected",
    exact: true,
    name: "CreatePost",
    component: RejectedLearningSession,
  },
  {
    path: "/superstar-admin/learning-session/pending/:id",
    exact: true,
    name: "learning-session",
    component: PendingLearningSessionDetails,
  },
  {
    path: "/superstar-admin/videocall",
    exact: true,
    name: "superstar-admin-learning-session-live-stream",
    component: LearningSessionLiveStream,
  },

  // Live Chat Session Route
  {
    path: "/superstar-admin/live-chat/dashboard",
    exact: true,
    name: "LiveChat",
    component: LiveChatDashboard,
  },
  {
    path: "/superstar-admin/live-chat/pending",
    exact: true,
    name: "LiveChat",
    component: LiveChatPending,
  },
  {
    path: "/superstar-admin/live-chat/live",
    exact: true,
    name: "LiveChat",
    component: LiveChatApproved,
  },
  {
    path: "/superstar-admin/live-chat/completed",
    exact: true,
    name: "LiveChat",
    component: LiveChatComplete,
  },
  {
    path: "/superstar-admin/live-chat/pending/:id",
    exact: true,
    name: "pending-livechat-details",
    component: LiveChatDetails,
  },
  {
    path: "/superstar-admin/live-chat/details/:id",
    exact: true,
    name: "LiveChat",
    component: LiveChatDetails1,
  },
  {
    path: "/superstar-admin/callDetails",
    exact: true,
    name: "LiveChat",
    component: CallDetails,
  },
  {
    path: "/superstar-admin/live-chat/create",
    exact: true,
    name: "live-event-create",
    component: LiveChatCreate,
  },
  {
    path: "/superstar-admin/live-chat/edit/:id",
    exact: true,
    name: "live-event-create",
    component: LiveChatEdit,
  },
  {
    path: "/superstar-admin/live-chat/profile/create",
    exact: true,
    name: "LiveChat",
    component: LiveChatProfileCreate,
  },
  {
    path: "/superstar-admin/live-chat/profile",
    exact: true,
    name: "LiveChat",
    component: LiveChatProfile,
  },
  {
    path: "/superstar-admin/live-chat-schedule",
    exact: true,
    name: "live-chat-schedule",
    component: LiveChatSchedule,
  },
  {
    path: "/superstar-admin/live-chat-schedule2",
    exact: true,
    name: "live-chat-schedule2",
    component: LiveChatSchedule2,
  },
  {
    path: "/superstar-admin/live-chat/registeruser/:live_chat_id",
    exact: true,
    name: "LiveChat",
    component: RegistertUser,
  },
  {
    path: "/superstar-admin/live-chat/add-schedule",
    exact: true,
    name: "LiveChat",
    component: AddSessionContent,
  },
  {
    path: "/superstar-admin/live-chat/stream/:slug",
    exact: true,
    name: "superstar-live-chat",
    component: LiveVideoChat,
  },

  // Question and Answers
  {
    path: "/superstar-admin/qna/dashboard",
    exact: true,
    name: "LiveChat",
    component: QnaDashboard,
  },
  {
    path: "/superstar-admin/qna/create",
    exact: true,
    name: "qna-event-create",
    component: CreateQnA,
  },
  {
    path: "/superstar-admin/qna/edit/:id",
    exact: true,
    name: "qna-event-edit",
    component: QnAEdit,
  },
  {
    path: "/superstar-admin/qna/pending",
    exact: true,
    name: "qna-pending",
    component: QnaPending,
  },
  {
    path: "/superstar-admin/qna/details/:id",
    exact: true,
    name: "qna-details",
    component: QnADetails,
  },
  {
    path: "/superstar-admin/qna/QnaMsgBox",
    exact: true,
    name: "qna-details",
    component: QnaMsgBox,
  },
  {
    path: "/superstar-admin/qna/live",
    exact: true,
    name: "Qna-Live",
    component: QnaLive,
  },
  {
    path: "/superstar-admin/qna/completed",
    exact: true,
    name: "LiveChat",
    component: QnaCompleted,
  },
  {
    path: "/superstar-admin/qna/Rejected",
    exact: true,
    name: "LiveChat",
    component: QnaRejected,
  },

  // MeetUp Event Route
  {
    path: "/superstar-admin/meetup-events/dashboard",
    exact: true,
    name: "meetup-events",
    component: AdminMeetupDashboard,
  },
  {
    path: "/superstar-admin/meetup-events/live",
    exact: true,
    name: "meetup-events",
    component: LiveMeetUp,
  },
  {
    path: "/superstar-admin/meetup-events/details/:slug",
    exact: true,
    name: "meetup-event-slot",
    component: EventSlot,
  },
  {
    path: "/superstar-admin/meetup-events/pending",
    exact: true,
    name: "meetup-events",
    component: PendingMeetUpList,
  },
  {
    path: "/superstar-admin/meetup-events/pending/:id",
    exact: true,
    name: "pending-meetup",
    component: PendingMeetUp,
  },
  {
    path: "/superstar-admin/meetup-events/completed",
    exact: true,
    name: "meetup-events",
    component: CompletedMeetup,
  },
  {
    path: "/superstar-admin/meetup-events/create",
    exact: true,
    name: "add-meetup",
    component: AddMeetUp,
  },
  {
    path: "/superstar-admin/meetup-events/edit/:id",
    exact: true,
    name: "add-meetup",
    component: EditMeetUp,
  },

  // @FIXME: Auditions Route
  {
    path: "/superstar-admin/auditions/round2-appeal",
    exact: true,
    name: "grand-final",
    component: AdminRoundTwoAppeal,
  },
  //   { path: '/superstar-admin/audition/pending', exact: true, name: 'grand-final', component: AdminPendingAudition },
  {
    path: "/superstar-admin/auditions/round1-appeal",
    exact: true,
    name: "grand-final",
    component: AdminRoundOneAppeal,
  },
  {
    path: "/superstar-admin/auditions/finish",
    exact: true,
    name: "grand-final",
    component: GrandFinish,
  },
  {
    path: "/superstar-admin/auditions/pending-audition",
    exact: true,
    name: "grand-final",
    component: AdminRequestForApproval,
  },
  // { path: '/superstar-admin/auditions/finish', exact: true, name: 'grand-final', component: GrandFinish },
  {
    path: "/superstar-admin/audition",
    exact: true,
    name: "audition",
    component: AdminAudition2,
  },
  {
    path: "/superstar-admin/audition/live-upload-show",
    exact: true,
    name: "audition",
    component: AdminAuditionLiveVideoFilter,
  },
  {
    path: "/superstar-admin/audition/create-event/:id",
    exact: true,
    name: "create-event",
    component: AdminAuditionCreateEvent,
  },
  {
    path: "/superstar-admin/audition/pending",
    exact: true,
    name: "audition-pending",
    component: PendingAudition,
  },
  {
    path: "/superstar-admin/audition/live",
    exact: true,
    name: "audition-pending",
    component: AdminAuditionLive,
  },

  // { path: '/superstar-admin/audition/details/:id', exact: true, name: 'audition-pending', component: AuditionsAdminStar},
  {
    path: "/superstar-admin/audition/details/:id",
    exact: true,
    name: "audition-pending",
    component: AdminPendingAudition,
  },

  {
    path: "/superstar-admin/audition/audition-video",
    exact: true,
    name: "audition-video",
    component: AdminAuditionVideo,
  },
  {
    path: "/superstar-admin/audition/audition-video-show",
    exact: true,
    name: "audition-video-show",
    component: AdminAuditionVideoShow,
  },
  {
    path: "/superstar-admin/audition/audition-video-show2",
    exact: true,
    name: "audition-video-show2",
    component: AdminAuditionVideoShow2,
  },

  //// Audition New Route
  {
    path: "/superstar-admin/audition/dashboard",
    exact: true,
    name: "dashboard",
    component: DashboardAudition,
  },
  {
    path: "/superstar-admin/audition/event",
    exact: true,
    name: "event",
    component: EventsLive,
  },
  {
    path: "/superstar-admin/audition/event/pending",
    exact: true,
    name: "pending",
    component: PendingEventAudition,
  },
  {
    path: "/superstar-admin/audition/event/request-approve",
    exact: true,
    name: "pending",
    component: EventRequestApproval,
  },
  {
    path: "/superstar-admin/audition/event/request-approve-view",
    exact: true,
    name: "pending",
    component: AdminRequestForApproval,
  },
  {
    path: "/superstar-admin/audition/round",
    exact: true,
    name: "round",
    component: AuditionRounds,
  },

  {
    path: "/superstar-admin/audition/certificate-create",
    exact: true,
    name: "certificate-create",
    component: CreateCertificate,
  },
  {
    path: "/superstar-admin/audition/certificate-request",
    exact: true,
    name: "certificate-request",
    component: RequestCertificate,
  },

  // Route
  {
    path: "/superstar-admin/upcoming-event",
    exact: true,
    name: "LiveChat",
    component: UpcomingEvent,
  },
  {
    path: "/superstar-admin/superstars",
    exact: true,
    name: "LiveChat",
    component: AddSuperStar,
  },
  {
    path: "/superstar-admin/superstar/edit/:star_id",
    exact: true,
    name: "LiveChat",
    component: EditSuperStar,
  },
  {
    path: "/superstar-admin/agreement-paper/:star_id",
    exact: true,
    name: "LiveChat",
    component: WelcomeSuperStarPrint,
  },

  {
    path: "/superstar-admin/eventDetails",
    exact: true,
    name: "eventDetails",
    component: EventDetails,
  },
  {
    path: "/superstar-admin/eventsuccess",
    exact: true,
    name: "eventsuccess",
    component: EventSuccess,
  },
  {
    path: "/superstar-admin/video-chat",
    exact: true,
    name: "video-chat",
    component: AdminVideoChatIcon,
  },
  {
    path: "/superstar-admin/video-chat-message",
    exact: true,
    name: "video-chat-message",
    component: AdminVideoChat,
  },

  // Greetings Route
  {
    path: "/superstar-admin/greetings",
    exact: true,
    name: "greetings",
    component: AdminGreetings,
  },
  {
    path: "/superstar-admin/greetings-all-request",
    exact: true,
    name: "greetingsAllRequest",
    component: AdminGreetingsAllRequest,
  },
  {
    path: "/superstar-admin/greetings-completed-list",
    exact: true,
    name: "AdminGreetingsCompletedList",
    component: AdminGreetingsCompletedList,
  },
  {
    path: "/superstar-admin/greetings-registered-list",
    exact: true,
    name: "greetingsRegistered",
    component: AdminGreetingsRegisteredList,
  },
  {
    path: "/superstar-admin/greetings/view/:id",
    exact: true,
    name: "greetingsView",
    component: AdminGreetingsView,
  },
  {
    path: "/superstar-admin/greetings-forwarded-list",
    exact: true,
    name: "greetingsForwardedList",
    component: AdminGreetingsForwarderdedToUserList,
  },
  {
    path: "/superstar-admin/notify",
    exact: true,
    name: "notify",
    component: Notify,
  },
  {
    path: "/superstar-admin/notify-schedule",
    exact: true,
    name: "notify-schedule",
    component: NotifySchedule,
  },
  {
    path: "/superstar-admin/notify-schedule/view",
    exact: true,
    name: "view",
    component: NotifyScheduleView,
  },
  {
    path: "/superstar-admin/greetings/greetingsForm",
    exact: true,
    name: "greetingsForm",
    component: AdminGreetingsForm,
  },
  // { path: "/superstar-admin/greetings/details", exact: true, name: "details", component: GreetingsDetails },
  // { path: "/superstar-admin/greetings/details/:greeting_id", exact: true, name: "details", component: GreetingsDetails },

  // =================================== Auction Routes =====================================
  {
    path: "/superstar-admin/auction",
    exact: true,
    name: "auction",
    component: LiveNowAuction,
  },
  {
    path: "/superstar-admin/auction/add-products",
    exact: true,
    name: "add-products",
    component: AddProductAuction,
  },
  {
    path: "/superstar-admin/edit-auction/:id",
    exact: true,
    name: "edit-auction-product",
    component: EditProductAuction,
  },
  {
    path: "/superstar-admin/live-bidding/:id",
    exact: true,
    name: "bidding",
    component: AdminBidding,
  },
  {
    path: "/superstar-admin/auction/product-list/pending",
    exact: true,
    name: "pending",
    component: PendingProductList,
  },
  {
    path: "/superstar-admin/auction/product-list/sold",
    exact: true,
    name: "sold",
    component: SoldProductList,
  },
  {
    path: "/superstar-admin/auction/product-list/sold/:id",
    exact: true,
    name: "sold",
    component: AuctionOrderView,
  },
  {
    path: "/superstar-admin/auction/product-list/unsold",
    exact: true,
    name: "unSold",
    component: UnsoldProductList,
  },
  {
    path: "/superstar-admin/auction/product-list/rejected",
    exact: true,
    name: "rejected",
    component: RejectedProductList,
  },
  {
    path: "/superstar-admin/auction/product-list/approvedOrDecline",
    exact: true,
    name: "approvedOrDecline",
    component: ApprovedOrDecline,
  },
  {
    path: "/superstar-admin/product/details/:id",
    exact: true,
    name: "PendingProduct",
    component: PendingProductDetails,
  },
  {
    path: "/superstar-admin/auction/live-biddings-checkout/:id",
    exact: true,
    name: "live-biddings",
    component: LiveBiddingsCheckout,
  },
  {
    path: "/superstar-admin/auction/confirm-or-edit-auction",
    exact: true,
    name: "live-biddings",
    component: ConfirmOrEditAuction,
  },

  // Souvenir
  {
    path: "/superstar-admin/souvenir",
    exact: true,
    name: "souvenir",
    component: SouvenirMain,
  },
  {
    path: "/superstar-admin/souvenir/create",
    exact: true,
    name: "souvenir",
    component: CreateEditSouvenir,
  },
  {
    path: "/superstar-admin/souvenir/edit/:id",
    exact: true,
    name: "souvenir",
    component: CreateEditSouvenir,
  },
  {
    path: "/superstar-admin/souvenir/details",
    exact: true,
    name: "souvenir",
    component: DetailsSouvenir,
  },
  {
    path: "/superstar-admin/souvenir/registered",
    exact: true,
    name: "souvenir",
    component: SouvenirRegisteredList,
  },
  {
    path: "/superstar-admin/souvenir/payment/due-list",
    exact: true,
    name: "souvenir",
    component: SouvenirPaymentDueList,
  },
  {
    path: "/superstar-admin/souvenir/payment/list",
    exact: true,
    name: "souvenir",
    component: SouvenirPaymentList,
  },
  {
    path: "/superstar-admin/souvenir/invoice/:id",
    exact: true,
    name: "souvenir",
    component: SouvenirOrderInvoice,
  },

  {
    path: "/superstar-admin/souvenir/add-products",
    exact: true,
    name: "add-products",
    component: AddProductSouvenir,
  },
  {
    path: "/superstar-admin/souvenir/edit-auction/:id",
    exact: true,
    name: "edit-auction-product",
    component: EditProductSouvenir,
  },

  // Star Showcase -> Marketplace
  {
    path: "/superstar-admin/marketplace",
    exact: true,
    name: "marketplace",
    component: Marketplace,
  },
  {
    path: "/superstar-admin/marketplace-orderlist",
    exact: true,
    name: "marketplace-orderlist",
    component: MarketPlaceOrderlist,
  },
  {
    path: "/superstar-admin/marketplace-orderlist-view/:id",
    exact: true,
    name: "marketplace-orderlist-view",
    component: MarketplaceOrderView,
  },
  {
    path: "/superstar-admin/marketplace-orderlist-invoice/:id",
    exact: true,
    name: "marketplace-orderlist-invoice",
    component: MarketplaceOrderInvoice,
  },  {
    path: "/superstar-admin/marketplace-orderlist-invoice-bng/:id",
    exact: true,
    name: "marketplace-orderlist-invoice",
    component: MarketplaceOrderInvoiceBng,
  },
  {
    path: "/superstar-admin/add-products-marketplace",
    exact: true,
    name: "add-products-marketPlace",
    component: AddProductFromMarketPlace,
  },
  {
    path: "/superstar-admin/confirm-or-edit-marketplace/:id",
    exact: true,
    name: "edit-jersey",
    component: ConfirmEditMarketplace,
  },
  {
    path: "/superstar-admin/product-list/approved",
    exact: true,
    name: "sold",
    component: ProductList,
  },
  {
    path: "/superstar-admin/product-list/pending",
    exact: true,
    name: "sold",
    component: ProductList,
  },
  {
    path: "/superstar-admin/edit-marketplace/:id",
    exact: true,
    name: "edit-marketplace",
    component: EditProductMarketPlace,
  },

  // { path: '/superstar-admin/souvenir/live-biddings', exact: true, name: 'live-biddings', component: CricketJerserAdmin }, // This is important, do not touch this code
  // { path: "/superstar-admin/souvenir/live-biddings", exact: true, name: "live-biddings", component: CricketJerserAdmin2 },
  // { path: '/superstar-admin/souvenir/live-biddings2', exact: true, name: 'live-biddings2', component:  CricketJerserAdmin3}, // This is important, do not touch this code
  {
    path: "/superstar-admin/live-chat/select-schedule",
    exact: true,
    name: "select-schedule",
    component: EventScheduleDatePick,
  },
  {
    path: "/superstar-admin/fangroup/view/:slug",
    exact: true,
    name: "FanbaseAdmin1",
    component: FanbaseAdmin1,
  },

  // @FIXME: Admin Fan Group Route
  {
    path: "/superstar-admin/fan-group",
    exact: true,
    name: "fan-group",
    component: AdminFanGroup,
  },
  {
    path: "/superstar-admin/fan-group-live",
    exact: true,
    name: "fan-group-live",
    component: AdminFanGroupLive,
  },
  {
    path: "/superstar-admin/create-fan-group",
    exact: true,
    name: "create-fan-group",
    component: CreateFanGroup,
  },
  {
    path: "/superstar-admin/pending-fan-group-Edit-delete/:slug",
    exact: true,
    name: "pending-fan-group",
    component: PendingFanGroup,
  },
  {
    path: "/superstar-admin/pending-fan-group-Edit/:slug",
    exact: true,
    name: "pending-fan-group",
    component: EditPendingFanGroup,
  },
  {
    path: "/superstar-admin/pending-fan-group-competition/:slug",
    exact: true,
    name: "pending-fan-group",
    component: CompletionBetweenStars,
  },
  {
    path: "/superstar-admin/invitation-fan-group",
    exact: true,
    name: "grand-final",
    component: FanGroupInvitation,
  },
  {
    path: "/superstar-admin/approved-fan-group",
    exact: true,
    name: "grand-final",
    component: AdminApprovedFanGroup,
  },
  {
    path: "/superstar-admin/pending-fan-group",
    exact: true,
    name: "grand-final",
    component: AdminPendingFanGroup,
  },
  {
    path: "/superstar-admin/approved-fan-group-edit-delete/:slug",
    exact: true,
    name: "grand-final",
    component: ApprovedFanGroup,
  },
  {
    path: "/superstar-admin/404",
    exact: true,
    name: "not-found",
    component: NotFound,
  },

  // Promo Videos
  {
    path: "/superstar-admin/promo-videos",
    exact: true,
    name: "allPromo",
    component: AllPromoVideos,
  },
  {
    path: "/superstar-admin/upload/promoVideo",
    exact: true,
    name: "createPromo",
    component: UploadPromoVideo,
  },
  {
    path: "/superstar-admin/pending/promoVideo",
    exact: true,
    name: "pendingPromo",
    component: PendingPromoVideo,
  },
  {
    path: "/superstar-admin/approved/promoVideo",
    exact: true,
    name: "pendingPromo",
    component: ApprovedPromoVideo,
  },
  {
    path: "/superstar-admin/promoVideo/edit/:id",
    exact: true,
    name: "editPromo",
    component: EditPromoVideo,
  },
  {
    path: "/superstar-admin/promoVideo/details/:id",
    exact: true,
    name: "pendingPromo",
    component: PendingDetailsPromoVideo,
  },
  {
    path: "/superstar-admin/live/promoVideo",
    exact: true,
    name: "pendingPromo",
    component: LivePromoVideo,
  },
  {
    path: "/superstar-admin/rejected/promoVideo",
    exact: true,
    name: "pendingPromo",
    component: RejectedPromoVideo,
  },
  // Static route for Audition Admin
];

export default AdminRoute;
